import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Calendar, BarChart, Zap, Users, Shield } from 'lucide-react';

const features = [
  {
    icon: MessageSquare,
    title: 'Smart Responses',
    description: 'AI-powered responses to customer inquiries across all platforms, available 24/7.'
  },
  {
    icon: Calendar,
    title: 'Automated Booking',
    description: 'Intelligent appointment scheduling that prevents double-bookings and maximizes your calendar.'
  },
  {
    icon: BarChart,
    title: 'Business Insights',
    description: 'Real-time analytics and insights to help you make data-driven decisions.'
  },
  {
    icon: Zap,
    title: 'Instant Automation',
    description: 'Set up automated workflows in minutes, not days or weeks.'
  },
  {
    icon: Users,
    title: 'Customer Management',
    description: 'Keep track of customer preferences and history for personalized service.'
  },
  {
    icon: Shield,
    title: 'Secure & Reliable',
    description: 'Enterprise-grade security with 99.9% uptime guarantee.'
  }
];

const Features = () => {
  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Everything You Need to Grow
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Powerful features that help you manage your business efficiently
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              className="relative p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="relative z-10">
                <feature.icon className="h-12 w-12 text-primary-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
              <div className="absolute inset-0 bg-gradient-to-br from-primary-50 to-transparent opacity-0 hover:opacity-100 transition-opacity rounded-xl" />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;